export default {
  sections: {
    settings: 'Definições',
  },
  status_switch: {
    label: 'Programa de fidelização',
    on: 'Ativado',
    off: 'Desativado',
    description: 'Os clientes ganham cashback em cada pedido e podem resgatá-lo no checkout.',
    description_missing: 'Guarde as definições abaixo para iniciar o seu programa de fidelização.',
  },
  alerts: {
    off: 'O seu programa de fidelização está desativado. Os clientes não ganham cashback em novos pedidos, não podem resgatar os seus pontos e não veem o programa na sua loja. Os pontos já acumulados mantêm-se e expiram normalmente.',
    expired: 'O seu programa de fidelização terminou. Ative-o para o reiniciar sem data de fim.',
  },
  form: {
    title: {
      label: 'Título',
    },
    percentage: {
      label: 'Percentagem de cashback',
      validation: {
        required: 'A percentagem de cashback é obrigatória',
        min: 'O valor mínimo da percentagem de cashback é {{value}}%',
        max: 'O valor máximo da percentagem de cashback é {{value}}%',
      },
    },
    point_lifetime: {
      label: 'Quantos dias pretende dar aos seus clientes para utilizarem os pontos?',
      validation: {
        min: 'Mínimo de {{value}} dias para a expiração dos pontos',
      },
    },
    min_spending_limit: {
      label: 'Limite mínimo de gasto para cashback',
      validation: {
        required: 'O limite mínimo de gasto é obrigatório',
        gt_zero: 'O limite mínimo de gasto deve ser superior a 0',
        lt_max_spending_limit: 'O limite mínimo de gasto deve ser inferior ao limite máximo de gasto',
      },
    },
    max_spending_limit: {
      label: 'Limite máximo de gasto para cashback',
      validation: {
        required: 'O limite máximo de gasto é obrigatório',
        gt_min_spending_limit: 'O limite máximo de gasto deve ser superior ao limite mínimo de gasto',
      },
    },
    has_welcome_bonus: {
      label: 'Bónus de boas-vindas',
      description: 'Ofereça aos novos clientes um bónus de cashback no registo',
    },
    welcome_bonus: {
      label: 'Valor do bónus de boas-vindas',
    },
    has_end_date: {
      label: 'Duração',
      options: {
        false: 'Ilimitado',
        true: 'Com data de fim específica',
      },
    },
    end_date: {
      label: 'Data de fim',
    },
    has_mobile_app_signup_bonus: {
      label: 'Bónus de Registo na App Mobile',
      description: 'Recompense os utilizadores que iniciem sessão na app mobile pela primeira vez',
    },
    mobile_app_signup_bonus: {
      label: 'Valor do Bónus',
    },
  },
  tags: {
    inactive: 'Inativo',
    active: 'Ativo',
    expired: 'Expirado',
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    changes_got_saved: 'Alterações guardadas',
    failed_to_save_changes: 'Falha ao guardar as alterações',
    turned_on: 'Programa de fidelização ativado',
    turned_off: 'Programa de fidelização desativado',
  },
};
